import * as React from "react";
import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import TextField from "@mui/material/TextField";
import axios from "axios";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import "./modal.css";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

export default function Modal({
	type,
	open,
	handleClose,
	title,
	item,
	wallets,
	setWallets,
}) {
	const [editValues, setEditValues] = useState({
		title: "",
		bill: "",
		category: "",
	});

	useEffect(() => {
		setEditValues({
			title: item?.title || "",
			bill: item?.wallet || "",
			category: "",
		});
	}, [item]);
	const handleChange = (e) => {
		const { name, value } = e.target;
		setEditValues({
			...editValues,
			[name]: value,
		});
	};
	const handleDelete = async (category) => {
		const updatedWallets = wallets.map((wallet) => ({
			...wallet,
			wallets: wallet.wallets.filter(
				(walletItem) => walletItem.title !== item.title
			),
		}));

		try {
			// Замените метод на delete, если API поддерживает это
			await axios.post("http://localhost:3001/wallets", updatedWallets);
			console.log("Данные успешно обновлены:", updatedWallets);
			setWallets(updatedWallets); // Обновляем состояние только при успехе
			handleClose();
		} catch (error) {
			console.error("Ошибка при обновлении JSON:", error);
		}
	};

	const handleEdit = async (item, title, bill) => {
		const updatedWallets = wallets.map((wallet) => ({
			...wallet,
			wallets: wallet.wallets.map((walletItem) =>
				walletItem.title === item.title
					? { ...walletItem, title, wallet: bill }
					: walletItem
			),
		}));

		try {
			await axios.post("http://localhost:3001/wallets", updatedWallets);
			setWallets(updatedWallets);
			handleClose();
		} catch (error) {
			console.error("Ошибка при обновлении JSON:", error);
		}
	};

	const handleAdd = async (category, title, bill) => {
		// Проверка, есть ли категория в wallets
		const categoryExists = wallets.some((wallet) => wallet.category === category);

		let updatedWallets;

		if (categoryExists) {
			// Если категория существует, то добавляем кошелёк в существующую категорию
			updatedWallets = wallets.map((wallet) => {
				if (wallet.category === category) {
					// Если это нужная категория, добавляем новый кошелёк
					return {
						...wallet,
						wallets: [...wallet.wallets, { title, wallet: bill }],
					};
				}
				return wallet; // Оставляем остальные категории без изменений
			});
		} else {
			// Если категории нет, создаём новый объект с этой категорией и кошельком
			updatedWallets = [
				...wallets,
				{ category, wallets: [{ title, wallet: bill }] },
			];
		}

		try {
			await axios.post("http://localhost:3001/wallets", updatedWallets);
			setWallets(updatedWallets);
			handleClose();
		} catch (error) {
			console.error("Ошибка при обновлении JSON:", error);
		}
	};

	return (
		<Dialog
			open={open}
			TransitionComponent={Transition}
			keepMounted
			onClose={handleClose}
			aria-describedby="alert-dialog-slide-description"
		>
			<DialogTitle className="modal-title">{title}</DialogTitle>
			<DialogContent>
				{type === "edit" ? (
					<div className="modal-edit">
						<TextField
							id="title"
							label="Заголовок"
							variant="outlined"
							name="title"
							value={editValues.title}
							onChange={handleChange}
						/>
						<TextField
							id="bill"
							label="Счёт"
							variant="outlined"
							name="bill"
							value={editValues.bill}
							onChange={handleChange}
							sx={{ width: "320px" }}
						/>
					</div>
				) : type === "add" ? (
					<div className="modal-add">
						<FormControl sx={{ m: 1, minWidth: 225 }}>
							<InputLabel id="category-select-label">Категория</InputLabel>
							<Select
								labelId="category-select-label"
								id="category-select"
								value={editValues.category}
								label="Категория"
								onChange={handleChange}
							>
								<MenuItem value="Криптовалюта">Криптовалюта</MenuItem>
								<MenuItem value="Карта">Карта</MenuItem>
							</Select>
						</FormControl>
						<TextField
							id="title"
							label="Заголовок"
							variant="outlined"
							name="title"
							value={editValues.title}
							onChange={handleChange}
						/>
						<TextField
							id="bill"
							label="Счёт"
							variant="outlined"
							name="bill"
							value={editValues.bill}
							onChange={handleChange}
							sx={{ width: "320px" }}
						/>
					</div>
				) : (
					<div className="modal-delete">
						Вы действительно хотите удалить способ оплаты <span>{item.wallet}?</span>
					</div>
				)}
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} color="error" variant="outlined">
					Отменить
				</Button>
				<Button
					onClick={() =>
						type === "edit"
							? handleEdit(item, editValues.title, editValues.bill)
							: type === "add"
							? handleAdd(editValues.category, editValues.title, editValues.bill)
							: handleDelete(item.category)
					}
					color="success"
					variant="outlined"
				>
					Подтвердить
				</Button>
			</DialogActions>
		</Dialog>
	);
}
